import React from "react";
import { motion } from "framer-motion";

const RaindropModalComponent = ({ children, setCurrentModalComponent }) => {
  const borderColor =
    "dark:border-color-dark-border-primary border-color-border-primary";
  const backgroundColor =
    "dark:bg-color-dark-background-secondary bg-color-background-secondary";

  return (
    <motion.div
      initial={{ y: 50, opacity: 0 }} // start 50px below and completely transparent
      animate={{ y: 0, opacity: 1 }} // move to its natural position and fully opaque
      transition={{ bounce: 0.4, type: "spring" }} // set animation duration to 1 second
      className="flex absolute w-full h-full items-center text-center justify-center z-10 "
    >
      <div>
        <div
          className={`flex flex-col p-4 z-10 rounded-lg border ${borderColor} ${backgroundColor} shadow-lg dark:shadow-none`}
        >
          <div className="flex w-full">
            <i
              onClick={() => setCurrentModalComponent(null)}
              className="fas fa-times text-color-dark-text-tertiary transition-all hover:text-color-dark-text-primary hover:scale-95"
            />
          </div>
          <div className="flex flex-col w-full h-full p-4">{children}</div>
        </div>
      </div>
    </motion.div>
  );
};

export default RaindropModalComponent;
